import React from 'react'
import { Field } from 'formik'
import { FormControl, TextField, useMediaQuery } from '@mui/material'
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import dayjs from 'dayjs'

function MobileDatePickerField({ label, formIk, ...rest }) {
  const { field, form, meta } = formIk
  const [value, setValue] = React.useState(
    field.value ? dayjs(field.value) : dayjs()
  )

  const handleChange = newValue => {
    setValue(newValue)
    form.setFieldValue(
      field.name,
      newValue ? dayjs(newValue).format(rest.inputFormat) : '',
      true
    )
  }

  return (
    <MobileDatePicker
      {...field}
      {...rest}
      value={value}
      error={false}
      inputFormat={rest.inputFormat}
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          onBlur={field.onBlur}
          error={meta.error && meta.touched && true}
          helperText={meta.touched && meta.error}
          label={label}
          name={field.name}
          fullWidth
        />
      )}
    />
  )
}

function DesktopDatePickerField({ label, formIk, ...rest }) {
  const { field, form, meta } = formIk

  const [value, setValue] = React.useState(
    field.value ? dayjs(field.value) : ''
  )

  const handleChange = newValue => {
    setValue(newValue)
    form.setFieldValue(
      field.name,
      newValue ? dayjs(newValue).format(rest.inputFormat) : '',
      true
    )
  }
  return (
    <DesktopDatePicker
      {...field}
      {...rest}
      value={value}
      error={false}
      inputFormat={rest.inputFormat}
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          onBlur={field.onBlur}
          error={meta.error && meta.touched && true}
          helperText={meta.touched && meta.error}
          label={label}
          name={field.name}
          fullWidth
        />
      )}
    />
  )
}

function MuiDatePicker({ name, ...props }) {
  const smDown = useMediaQuery(theme => theme.breakpoints.down('sm'))
  return (
    <Field name={name}>
      {formIk => (
        <FormControl
          fullWidth
          error={Boolean(formIk.meta.error) && formIk.meta.touched}
        >
          {smDown ? (
            <MobileDatePickerField {...props} formIk={formIk} />
          ) : (
            <DesktopDatePickerField {...props} formIk={formIk} />
          )}
        </FormControl>
      )}
    </Field>
  )
}

export default MuiDatePicker
